let backendHost;

const hostname = window && window.location && window.location.hostname;

if (hostname === 'localhost') {
    backendHost = 'http://localhost:8080';
} else if (hostname === 'umbrel-dev' || hostname === 'order.umbrel.thewebpeople.ca') {
    backendHost = 'https://order.umbrel.thewebpeople.ca';
} else {
    backendHost = 'https://order.bevvy.ca';
}

export const API_ROOT = `${backendHost}/api`;